import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setBulkOrderCostCenter, setCostCenterByGroup, setCostCenterByBranch, setCostCenterByRegion, setCostCenterBySearchString, setCostCenterGroups, setCostCenters, setCostCentersWithDivisionId } from 'Store/Organization/CostCenters/CostCentersAction';
import { GET_BULK_ORDER_COST_CENTER, GET_COST_CENTERS, GET_COST_CENTERS_BY_BRANCH, GET_COST_CENTER_BY_GROUP, GET_COST_CENTER_BY_REGION, GET_COST_CENTER_BY_SEARCH_STRING, GET_COST_CENTER_GROUPS } from 'Store/Organization/CostCenters/CostCentersType';
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setIsDropDownsLoading } from 'Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction';

function* getCostCenters(divisionId: any): any {
    let payloadData: IPayload = {
        apiType: apiType.Organization,
        endpoint: `organizations/dropdown/costcenters/${divisionId.divisionId}`,
        apiMethod: apiMethod.GET,
        payload: null
    }

    try {
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCostCenters(response));
        yield put(setCostCentersWithDivisionId({ id: divisionId, option: response }));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* getCostCenterGroups(regionId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/dropdown/approval/groups/${regionId.regionId}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post, API_URL.PostWebApp, payloadData

        );
        yield put(setCostCenterGroups(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* getCostCenterByRegion(regionId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/dropdown/approval/costcenter/${regionId.regionId}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCostCenterByRegion(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* getCostCenterByGroup(groupId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/dropdown/approval/groups/costcenter/${groupId.groupId}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post, API_URL.PostWebApp, payloadData

        );
        yield put(setCostCenterByGroup(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* getBulkOrderCostCenter(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/dropdown/bulkorder/costcenter`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(OrganizationApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setBulkOrderCostCenter(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setBulkOrderCostCenter([]))
        yield put(setIsDropDownsLoading(false))
    }
}


function* getCostCenterByBranch(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/dropdown/costcenter/branch/${req.branchId}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCostCenterByBranch(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCostCenterByBranch([]));
        yield put(globalLoaderText(""));
    }
}

function* getCostCenterBySearch(req: any): any {
    try {
        let endpoint = req?.isHierarchy ? 'organizations/structure/costcenter' : 'organizations/costcenter'
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `${endpoint}/${req.searchText}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCostCenterBySearchString(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCostCenterBySearchString([]));
        yield put(globalLoaderText(""));
    }
}

function* watchGetCostCenters() {
    yield takeEvery(GET_COST_CENTERS, getCostCenters)
    yield takeEvery(GET_COST_CENTER_GROUPS, getCostCenterGroups)
    yield takeEvery(GET_COST_CENTER_BY_REGION, getCostCenterByRegion)
    yield takeEvery(GET_COST_CENTER_BY_GROUP, getCostCenterByGroup)
    yield takeEvery(GET_BULK_ORDER_COST_CENTER, getBulkOrderCostCenter)
    yield takeEvery(GET_COST_CENTERS_BY_BRANCH, getCostCenterByBranch)
    yield takeEvery(GET_COST_CENTER_BY_SEARCH_STRING, getCostCenterBySearch)
}

export default function* combinedSaga() {
    yield all([
        watchGetCostCenters()
    ])
}
